// extracted by mini-css-extract-plugin
export default {"BlocAdresse":"BlocAdresse_BlocAdresse__-omgJ","AdresseEtIcone":"BlocAdresse_AdresseEtIcone__Xy2FS","Adresse":"BlocAdresse_Adresse__Dxml8"};